import styled from 'astroturf/react'
import { Button } from '@calendly/ui/components/button'

import { useI18n } from 'locales'

import Header from './header'
import _ContinueButton from "no_user-ContinueButton.module.css!=!astroturf/inline-loader?style=1!/home/runner/work/booking/booking/frontend/components/select_date_time/mutual_availability_notice/login/no_user.js?styleId=ContinueButton";


const ContinueButton = /*#__PURE__*/styled(Button, null, {
  displayName: "ContinueButton",
  styles: _ContinueButton
})

export default ({ closePopup, email }) => {
  const { i18n } = useI18n()
  return (
    <>
      <Header>{i18n.t('booking.mutual_availability.login.no_user', { email })}</Header>
      <ContinueButton
        wide
        onClick={closePopup}
      >
        {i18n.t('booking.mutual_availability.login.continue_scheduling')}
      </ContinueButton>
    </>
  )
}
